<template>
<Main>
    <v-container>
        <v-card class="mx-auto">
            <v-card-text>
                <p class="display-1 text--primary">
                    Upload Mapping Sales Assignment
                    <v-btn small color="warning" @click="downloadCSV()">Download Template</v-btn>
                </p>
                <div class="text--primary">
                    <!-- {{ this.SELECTED_MONTH_PERIOD + " - " + this.SELECTED_YEAR_PERIOD + " - " + this.SELECTED_BRANCH}} -->
                    <!-- {{ this.VSELECT_BRANCH }} -->
                    <v-row>
                        <v-col md="12" sm="12">
                            <!-- {{ "CSV : " + this.JSON_FILE_UPLOAD }} -->
                            <FilePond name="test" ref="pond" class-name="my-pond" label-idle="Click or Drop files here..." accepted-file-types="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv, application/csv" :files="this.FILE_UPLOAD" :init="handleFilePondInit" v-on:updatefiles="handleFilePondUpdateFile" v-on:removefile="handleFilePondRemoveFile" />
                        </v-col>
                        <v-col md="12" sm="12">
                            <v-btn small color="warning" class="mb-3 float-right" @click="confirmModal(submitUpload)">Submit Uploaded File</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
        <v-card>
            <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

            <v-card-text>It will submit all data which is imported to database. Please give
                confirmation before you submit.</v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="red darken-1" text @click="isOpenModalConfirm = false">Cancel</v-btn>

                <v-btn color="green darken-1" text @click="methodAction">Submit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
</Main>
</template>

<script>
import Main from "@/Main.vue";
import XLSX from "xlsx";
import moment from "moment";

// Import the plugin code
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

// Import Vue FilePond
import vueFilePond, {
    setOptions
} from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

setOptions({
    allowMultiple: false,
});

const JSON_FOR_DOWNLOAD = [{
    CUSTOMER_ID_REF: "",
    CUSTOMER_NAME: "",
    BISNIS: "",
    TYPE_DESC: "",
    POSITION: "",
    ADD_SALESMAN_POSITION: "",
    START_DATE: "YYYY-MM-DD",
    END_DATE: "YYYY-MM-DD",
}, ];

export default {
    components: {
        Main,
        FilePond,
    },
    data() {
        return {
            methodAction: "",
            isOpenModalConfirm: false,
            FILE_UPLOAD: [],
            JSON_FILE_UPLOAD: [],
            search: "",
            dtLoading: false,
            isShowSnackbar: false,
            snackbarText: "",
            isLoading: false,
        };
    },
    methods: {
        confirmModal: function (method) {
            this.isOpenModalConfirm = true;
            this.methodAction = method;
        },
        handleFilePondInit() {},
        handleFilePondUpdateFile(file) {
            let self = this;
            let counter = true;

            const UPLOADED_CSV = file.map((fileItems) => fileItems.file);
            const userData = JSON.parse(localStorage.getItem("userData"));

            var files = UPLOADED_CSV,
                f = files[0];

            if (f) {
                var reader = new FileReader();
                reader.onload = (e) => {
                    var data = new Uint8Array(e.target.result);
                    var workbook = XLSX.read(data, {
                        type: "array",
                        cellDates: true
                    });
                    let sheetName = workbook.SheetNames[0];
                    /* DO SOMETHING WITH workbook HERE */
                    let worksheet = workbook.Sheets[sheetName];
                    const XLSXJSON = XLSX.utils.sheet_to_json(worksheet);
                    console.log(XLSXJSON);
                    if (self.JSON_FILE_UPLOAD < 1) {
                        for (let XLSXJSONDATA of XLSXJSON) {
                            if (
                                (XLSXJSONDATA.CUSTOMER_ID_REF != undefined,
                                    XLSXJSONDATA.CUSTOMER_NAME != undefined,
                                    XLSXJSONDATA.BISNIS != undefined,
                                    XLSXJSONDATA.TYPE_DESC != undefined,
                                    XLSXJSONDATA.POSITION != undefined,
                                    XLSXJSONDATA.ADD_SALESMAN_POSITION != undefined,
                                    XLSXJSONDATA.START_DATE != undefined,
                                    XLSXJSONDATA.END_DATE != undefined)
                            ) {
                                self.JSON_FILE_UPLOAD.push({
                                    customerId: XLSXJSONDATA.CUSTOMER_ID_REF,
                                    customerName: XLSXJSONDATA.CUSTOMER_NAME,
                                    bisnis: XLSXJSONDATA.BISNIS,
                                    typeDesc: XLSXJSONDATA.TYPE_DESC,
                                    position: XLSXJSONDATA.POSITION,
                                    addSalesmanPosition: XLSXJSONDATA.ADD_SALESMAN_POSITION,
                                    startDate: moment(new Date(XLSXJSONDATA.START_DATE)).format("YYYY-MM-DD"),
                                    endDate: moment(new Date(XLSXJSONDATA.END_DATE), ).format("YYYY-MM-DD"),
                                    userIdUpdate: userData.USER_ID,
                                });
                            }
                        }
                    }

                    // console.log(self.JSON_FILE_UPLOAD);
                };
                reader.readAsArrayBuffer(f);
            }
        },
        handleFilePondRemoveFile(error, file) {
            this.$refs.pond.removeFile();
            this.JSON_FILE_UPLOAD = [];
        },
        submitUpload() {
            if (this.JSON_FILE_UPLOAD.length > 0) {
                this.isOpenModalConfirm = false;
                this.isLoading = true;
                this.$http
                    .post("/mapping-sales-assignment/insert", this.JSON_FILE_UPLOAD, {
                        headers: {
                        "api-key": this.$apiKey
                        }
                    })
                    .then((res) => {
                        const {
                            success,
                            message
                        } = res.data;
                        console.log(res)
                        if (success) {
                            this.isLoading = false;
                            this.arrRow = [];
                            this.showSnackbar("Submit Success...");
                        } else {
                            this.isLoading = false;
                            this.showSnackbar(message);
                        }
                    })
                    .catch((err) => {
                        this.isLoading = false;
                        this.showSnackbar(err.toString());
                    });
            } else {
                this.isLoading = false;
                this.isOpenModalConfirm = false;
                this.showSnackbar("Please Upload CSV File First !");
            }
        },
        downloadCSV() {
            const workBook = XLSX.utils.book_new(); // create a new blank book
            const workSheet = XLSX.utils.json_to_sheet(JSON_FOR_DOWNLOAD);
            XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
            XLSX.writeFile(workBook, "Template Upload Mapping Sales Assignment.xlsx"); // initiate a file download in browser
        },
        showSnackbar(text) {
            this.snackbarText = text;
            this.isShowSnackbar = true;
        },
    },
};
</script>
